module.exports = __webpack_public_path__ + "img/flag-plug-icon.2e0e446b.svg";